const response = {

    "payload": [
        {
            "userId": 1,
            "firstName": 'Carolina',
            "middleName": '',
            "lastName": "Narvaez",
            "secondLastName": "Rojas",
            "emailAddress": "usuario1@example.com",
            "identification": {
                "identificationId": "1",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1122443555",
            "role": {
                "roleId": "1",
                "nameRole": "Desarrollo",
            },
            "userDetailResponse": {
            "userDetailId": 2136,
            "cellPhoneNumber": null,
            "gender": {
                "genderId": 1,
                "gernderName": "Masculino",
                "codeGender": "M"
            },
            "countryPhoneCode": {
                "countryPhoneCodeId": 1,
                "countryPhoneCode": 57
            },
            "userState": {
                "stateId": 1,
                "stateName": "Activo"
            },
            "creationDate": "2024-12-03T15:17:36",
            "isBlocked": true
        }

        },
        {
            "userId": 2,
            "firstName": 'Alexandra',
            "middleName": 'maria',
            "lastName": "Marchan",
            "secondLastName": "Gaviria",
            "emailAddress": "usuario2@example.com",
            "identification": {
                "identificationId": "2",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1122334455",
            "role": {
                "roleId": "2",
                "nameRole": "Recursos humanos",
            },
            "userDetailResponse": {
            "userDetailId": 2136,
            "cellPhoneNumber": null,
            "gender": {
                "genderId": 1,
                "gernderName": "Masculino",
                "codeGender": "M"
            },
            "countryPhoneCode": {
                "countryPhoneCodeId": 1,
                "countryPhoneCode": 57
            },
            "userState": {
                "stateId": 1,
                "stateName": "Activo"
            },
            "creationDate": "2024-12-03T15:17:36",
            "isBlocked": false
        },
    },
        {
            "userId": 3,
            "firstName": 'Carolina',
            "middleName": '',
            "lastName": "Narvaez",
            "secondLastName": "Rojas",
            "emailAddress": "u@e.com",
            "identification": {
                "identificationId": "2",
                "identificationType": "Cédula de ciudadanía",
                "identificationNameShort": "C.C"
            },
            "identificationNumber": "1122334455",
            "role": {
                "roleId": "1",
                "nameRole": "Area financiera",
            },
            "userDetailResponse": {
            "userDetailId": 2136,
            "cellPhoneNumber": null,
            "gender": {
                "genderId": 1,
                "gernderName": "Masculino",
                "codeGender": "M"
            },
            "countryPhoneCode": {
                "countryPhoneCodeId": 1,
                "countryPhoneCode": 57
            },
            "userState": {
                "stateId": 2,
                "stateName": "bloqueado"
            },
            "creationDate": "2024-12-03T15:17:36",
            "isBlocked": true

        },


        }
    ]
}

const responseDelete = {

    "payload": [
        {
            "code": 'U2',
            "message": 'Se ha eliminado exictosamente jeje'
        },
    ]
}

const responseCreate = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Se ha creado exitosamente el usuario administrativo'
        }
    }
};

const responseType = {

    "payload": [
        {
            "identificationId": "1",
            "identificationType": "cedula",
            "identificationNameShort": "PASS"

        },
        {
            "identificationId": "2",
            "identificationType": "tarjeta de identidad",
            "identificationNameShort": "PASS"

        },
        {
            "identificationId": "3",
            "identificationType": "Passaporte",
            "identificationNameShort": "PASS"

        }
    ]
};

const responseTypeRol = {

    "payload": [
        {
            "roleId": "1",
            "nameRole": "Desarrollo",

        },
        {
            "roleId": "2",
            "nameRole": "Recursos humanos",

        },
        {
            "roleId": "3",
            "nameRole": "Area financiera",

        }
    ]
};
const responseUpDate = {
    status: 200,
    data: {
        "payload": {
            "code": 200,
            "message": 'Se ha actualizado exitosamente el usuario administrativo'
        }
    },
};

const responseId = {

    "payload":
    {
        "companyId": "12222",
        "companyName": "Lucasian",
        "userId": 1,
        "firstName": 'Carolina',
        "middleName": '',
        "lastName": "Narvaez",
        "secondLastName": "Rojas",
        "emailAddress": "usuario1@example.com",
        "identification": {
            "identificationId": "1",
            "identificationType": "Cédula de ciudadanía",
            "identificationNameShort": "C.C"
        },
        "identificationNumber": "1122443555",
        "role": {
            "roleId": "1",
            "nameRole": "Area financiera",
        }

    },

};

const responseCompanyId = {

    "payload": {
        "userId": '2',
        "firstName": 'Alexandra',
        "middleName": 'maria',
        "lastName": "Marchan",
        "secondLastName": "Gaviria",
        "emailAddress": "usuario2@example.com",
        "identification": {
            "identificationId": "2",
            "identificationType": "Cédula de ciudadanía",
            "identificationNameShort": "C.C"
        },
        "identificationNumber": "1122334455",
        "role": {
            "roleId": "2",
            "nameRole": "Recursos humanos",
        },
        "userDetailResponse": {
        "userDetailId": 2136,
        "cellPhoneNumber": null,
        "gender": {
            "genderId": 1,
            "gernderName": "Masculino",
            "codeGender": "M"
        },
        "countryPhoneCode": {
            "countryPhoneCodeId": 1,
            "countryPhoneCode": 57
        },
        "userState": {
                "stateId": 2,
                "stateName": "bloqueado"
            },
            "creationDate": "2024-12-03T15:17:36",
            "isBlocked": true
    },
},

};

const responseGender = {

    "payload": [
        {
            "genderId": "1",
            "gernderName": "Masculino",

        },
        {
            "genderId": "2",
            "gernderName": "Femenino",

        },
        {
            "genderId": "3",
            "gernderName": "N/A",

        }
    ]
};

const responseUserStatus= {

    "payload": [
        {
            "stateId": 1,
            "stateName": "Activo",

        },
        {
            "stateId": 2,
            "stateName": "Inactivo",

        },
    ]
};

const responsePostUserStatus= {

    "payload": [
        {
            "userId": 231,
            "stateId" : 1,
            "observation" : "Bloqueado por que puedo y no me da miedo y que va a hacer"
        }
    ]
};

const responseSearchAffiliate = {
    "payload": [
        {
            "userId": 100,
            "firstName": "Carlos",
            "lastName": "Rodríguez",
            "emailAddress": "carlos.rodriguez@example.com",
            "identificationNumber": "123456789"
        },
        {
            "userId": 101,
            "firstName": "María",
            "lastName": "González",
            "emailAddress": "maria.gonzalez@example.com",
            "identificationNumber": "987654321"
        },
        {
            "userId": 102,
            "firstName": "Juan",
            "lastName": "Pérez",
            "emailAddress": "juan.perez@example.com",
            "identificationNumber": "456789123"
        },
        {
            "userId": 103,
            "firstName": "Ana",
            "lastName": "Martínez",
            "emailAddress": "ana.martinez@example.com",
            "identificationNumber": "789123456"
        }
    ]
};

export const service = {
    getUserAdmin: () => new Promise(resolve => {
        setTimeout(resolve({ data: response }), 1000);
    }),
    getUserAdminDelete: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseDelete }), 1000);
    }),
    postUserAdminCreate: () => new Promise(resolve => {
        setTimeout(() => resolve(responseCreate), 2000);
    }),
    getUserAdminTypDocument: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseType }), 1000);
    }),
    getUserAdminTypeRol: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseTypeRol }), 1000);
    }),
    upDateUserAdmin: () => new Promise(resolve => {
        setTimeout(resolve({ responseUpDate }), 2000);
    }),
    getUserAdminCompanyId: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCompanyId }), 1000);
    }),

    getUserAdminId: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseId }), 1000);
    }),

    upDateUserAdminCompanyId: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseUpDate }), 1000);
    }),

    postCargueAffiliatedUser: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCreate }), 1000);
    }),

    getAffiliatedGender: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseGender }), 1000);
    }),

    getUserStatus: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseUserStatus }), 1000);
    }),

    postUserStatus: () => new Promise(resolve => {
        setTimeout(resolve({ data: responsePostUserStatus }), 1000);
    }),

    getSearchAffiliate: (_idGroup, _idEmpresa, _idUsuario, searchTerm) => new Promise(resolve => {
        setTimeout(() => {
            const filteredUsers = responseSearchAffiliate.payload.filter(user => 
                user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.emailAddress.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.identificationNumber.includes(searchTerm)
            );
            resolve({ data: filteredUsers });
        }, 800);
    }),
};